import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  deleteBookmark,
  fetchAllBookmarks,
  handleBookmarksPagination,
  setSearchQuery,
  fetchmainCategories,
  fetchsubCategories
} from "../../redux/slices/adminSlice";
import BookmarkTableData from "./BookmarkTableData";
import Swal from "sweetalert2";
import useDebounce from "../../hooks/useDebounce";

const AdminBookmarks = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { mainCategories, subCategories, adminBookmarks, totalBookmarks, pagination, searchQuery, loading } =
    useSelector((state) => state.admin);
  const debouncedQuery = useDebounce(searchQuery, 500);  

  const [selectedBookmarks, setSelectedBookmarks] = useState([]);  
  const [selectedCategory, setSelectedCategory] = useState(''); 
  const [selectedSubCategory, setSelectedSubCategory] = useState('');

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCategory(selectedValue);
    setSelectedSubCategory('');
  };

  const handleSelectChangesubCategory = (e) => {
    const selectedValued = e.target.value;
    setSelectedSubCategory(selectedValued);
  };
  
  useEffect(() => {
    dispatch(fetchmainCategories());
  }, [dispatch]);

  useEffect(() => {
    if(selectedCategory) {  
      dispatch(fetchsubCategories({category_id: selectedCategory}));
    }
  }, [dispatch, selectedCategory]);

  useEffect(() => {
    dispatch(fetchAllBookmarks({ token, category_id: selectedCategory || undefined, sub_category_id: selectedSubCategory || undefined }));
  }, [dispatch, token, debouncedQuery, selectedCategory, selectedSubCategory]);
  

  useEffect(() => {
    return () => {
      dispatch(setSearchQuery(""));
    };
  }, [dispatch]);


  const handlePagination = async (url) => {
    dispatch(handleBookmarksPagination({ url, token }));
  };

  const handleSelectAllBookmarks = () => {
    if (selectedBookmarks?.length === adminBookmarks?.length) {
      setSelectedBookmarks([]);
    } else {
      setSelectedBookmarks(
        adminBookmarks?.map((bookmark) => bookmark?.bookmark_id)
      );
    }
  };

  const handleSelectOneBookmark = (bookmark_id) => {
    setSelectedBookmarks((prev) => {
      if (prev.includes(bookmark_id)) {
        return prev?.filter((id) => id !== bookmark_id)
      }else{
        return [...prev, bookmark_id];
      }
    });
  };

  const deleteBookmarkSelected = async (id) => {
    if (!id) {
      toast.warning("No bookmark found!");
      return;
    }
    const confirmDelete = async () => {
      await dispatch(deleteBookmark({ ids: selectedBookmarks }))
        .unwrap()
        .then(() => {
          setSelectedBookmarks([]);
          dispatch(fetchAllBookmarks(token));
        })
        .catch((err) => {
          console.error("Error deleting bookmark: " + err.message);
        });
    };

    // Show confirmation toast with Yes/No buttons
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d9534f",
      cancelButtonColor: "#5bc0de",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDelete();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };

  //Delete single user
  const deleteSingleBookmark = (ids) => {
    if (!ids || ids.length === 0) {
      toast.warning("No users selected!");
      return;
    }
    const confirmDelete = () => {
      dispatch(deleteBookmark({ ids: ids }))
        .unwrap()
        .then(() => {
          toast.success("Bookmark deleted successfully!");
          dispatch(fetchAllBookmarks(token));
        })
        .catch((err) => {
          toast.error("Error deleting Bookmark: " + err.message);
        });
    };

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d9534f",
      cancelButtonColor: "#5bc0de",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDelete();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };
console.log(adminBookmarks, 'adminBookmarks')
  return (
    <div className="w-full lg:ps-64">
      <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <div className="bg-white border border-gray-200 overflow-x-auto rounded-xl shadow-2xs overflow-hidden">
          <div className="px-6 py-4 grid gap-3 md:flex md:justify-between md:items-center border-b border-gray-200">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">
                Bookmarks
              </h2>
              <p className="text-sm text-gray-600">
                List all the bookmarks.
              </p>
            </div>
            <div className="w-full flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-end sm:mr-4">
             
            <select id="main-category"
              name="main-category"
              className="block w-full sm:w-auto px-4 py-2 text-sm border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-0 focus:border-gray-400"

              value={selectedCategory}
              onChange={handleSelectChange}>
              <option value="">Select a category</option>
              {mainCategories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.title}
                </option>
              ))}
            </select>
          
            <select id="sub-category"
              name="sub-category"
              className="block w-full sm:w-auto px-4 py-2 text-sm border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-blue-500 focus:border-blue-500"
              onChange={handleSelectChangesubCategory}
             >
              <option>Sub Category</option>
              {subCategories.map((subcategory) => (
                <option key={subcategory.id} value={subcategory.id}>
                  {subcategory.title}
                </option>
              ))}
              </select>

            </div>
            <div>
              <div className="inline-flex gap-x-2">
                <button
                  onClick={deleteBookmarkSelected}
                  className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-2xs hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-gray-50"
                  disabled={selectedBookmarks?.length === 0 ? "disabled" : ""}
                >
                  Delete all ({selectedBookmarks?.length})
                </button>
              </div>
            </div>
          </div>
             {
             loading?.fetchAllBookmarks ? (
              <div className="flex flex-wrap justify-center w-full py-10">
                <span className="loader"></span>
              </div>
            ) :
          adminBookmarks && adminBookmarks?.length > 0 ? (
            <>
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-start">
                      <label
                        htmlFor="hs-at-with-checkboxes-main"
                        className="flex"
                      >
                        <input
                          type="checkbox"
                          onChange={handleSelectAllBookmarks}
                          checked={
                            adminBookmarks?.length > 0 &&
                            selectedBookmarks?.length === adminBookmarks?.length
                          }
                          className="me-2 shrink-0 border-gray-300 rounded-sm text-blue-600 focus:ring-blue-500 checked:border-blue-500 disabled:opacity-50 disabled:pointer-events-none"
                          id="hs-at-with-checkboxes-main"
                        />
                        {/* <span className="text-xs font-semibold uppercase text-gray-800">
                        ID
                      </span> */}
                      </label>
                    </th>
                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Thumbnail
                        </span>
                      </div>
                    </th>
                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Title
                        </span>
                      </div>
                    </th>
                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Website Url
                        </span>
                      </div>
                    </th>
                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Saved By User
                        </span>
                      </div>
                    </th>

                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Created
                        </span>
                      </div>
                    </th>

                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Added To
                        </span>
                      </div>
                    </th>

                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Category
                        </span>
                      </div>
                    </th>

                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Sub Category
                        </span>
                      </div>
                    </th>
                    <th scope="col" className="px-6 py-3 text-start">
                      <div className="flex items-center gap-x-2">
                        <span className="text-xs font-semibold uppercase text-gray-800">
                          Action
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-200">
                  {adminBookmarks &&
                    adminBookmarks?.length > 0 &&
                    adminBookmarks?.map((bookmark, index) => {
                      return (
                        <React.Fragment
                          key={bookmark?.id || `bookmark-${index}`}
                        >
                          <BookmarkTableData
                            bookmark={bookmark}
                            deleteSingleBookmark={deleteSingleBookmark}
                            selectedBookmarks={selectedBookmarks}
                            handleSelectOneBookmark={handleSelectOneBookmark}
                          />
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </>
          ) : null}
          <div className="px-6 py-4 grid gap-3 md:flex md:justify-between md:items-center border-t border-gray-200">
            {
              totalBookmarks >0 &&
            <div>
              <p className="text-sm text-gray-600">
                <span className="font-semibold text-gray-800">
                  {totalBookmarks}
                </span>{" "}
                results
              </p>
            </div>
            }

            {/* Counter Pagination */}
            <div className="inline-flex gap-x-2">
              {pagination &&
                pagination?.length > 3 &&
                pagination.map((pageNumber, index) => {
                  return (
                    <button
                      key={index}
                      type="button"
                      disabled={pageNumber?.url === null}
                      onClick={() => handlePagination(pageNumber?.url)}
                      className={`${
                        pageNumber?.active ? "bg-gray-100" : "bg-white"
                      } py-1.5 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 text-gray-800 shadow-2xs hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-gray-50`}
                    >
                      {index === 0
                        ? "<"
                        : index === pagination?.length - 1
                        ? ">"
                        : pageNumber?.label}
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminBookmarks;
